import { Button, ButtonProps } from './button.component';

import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUp from '@mui/icons-material/KeyboardArrowUp';



export type OpenCloseButtonProps = {
  open: boolean;
  openTitle: string;
  closeTitle: string;
} & ButtonProps;


export const OpenCloseButton = ({ open, openTitle, closeTitle, endIcon: _endIcon, ...props }: OpenCloseButtonProps) => {
  const endIcon = open ? <KeyboardArrowUp /> : <KeyboardArrowDown />;
  const title = open ? closeTitle : openTitle;

  return (
    <Button endIcon={_endIcon || endIcon} variant="text" {...props}>{title}</Button>
  );
};
